<template>
    <div class="header__top_account_dotsbutton"

    >
        <component-button-menu
            :name="'header-top-account-dots-button'"
            :icon="true"
            :icon-name="'more-vertical'"
            :icon-raw="true"
            :theme="''"
            :menu-style="'second'"
            :buttons="[
                {
                    key: 'what-new',
                    name: `What's new`,
                    icon: true,
                    iconName: 'external-link',
                    iconAlign: 'right'
                }
            ]"
            @emit-what-new="redirectToWhatNew"
        ></component-button-menu>
    </div>
</template>

<script>
import ComponentButtonMenu from '@/components/default/shared/ComponentButtonMenu'
export default {
  name: 'header-top-account-dots-button',
  components: { ComponentButtonMenu },
  methods: {
    redirectToWhatNew () {
      window.open('https://formguide.melearning.co.uk/hc/en-gb/articles/360014342177-Release-notes', '_blank')
    }
  }
}
</script>
